import React from "react";
import {Button, Col, Form, Row} from "antd";
import Divider from "antd/es/divider";

import {
    createCorporateAccountUser, deleteFile, getCorporateAccountDetails,
    getCorporateAccountUserDetails,
    getCountryList, getIdType,
    getNationalityList, upload
} from "../api/api";
import {displayGenericError} from "../common/notifications";


import UploadWrapper from "./UploadWrapper";
import Radio from "antd/es/radio";

export default class CustomerAcceptanceCorporateAccountUser extends React.Component {
    state = {
        corporateAccountUsers: [{crpUserType: 'UBO', crpAccType: 'INDIVIDUAL'}],
        nationalities: [],
        countries: [],
        documents: [],
        idTypes:[]
    }
    handleUpload = ({file, type, index, itemId}) => {
        if (!(typeof index === "number")) {
            return upload({id: itemId, file, type, isCorporateUsers: true})
                .then(res => {
                    // this.getCorporateAccountDetails();
                    let corporateAccountUsers = this.state.corporateAccountUsers;
                    let user = this.state.corporateAccountUsers.filter(s => s.id === itemId)[0];

                    if (user.crpAccType === 'INDIVIDUAL') {
                        if (!user.attachedFiles) {
                            user.attachedFiles = []
                        } else {
                            if (res.attachedFileType === 'IDENTITY_CARD_FRONT') {
                                user.identityCardFront = res;
                            } else if (res.attachedFileType === 'IDENTITY_CARD_BACK') {
                                user.identityCardBack = res;
                            } else if (res.attachedFileType === 'PASSPORT') {
                                user.passport = res;
                            } else if (res.attachedFileType === 'PROOF_OF_ADDRESS') {
                                user.proofOfAddress = res;
                            }

                        }
                    } else {
                        if (!user.attachedFiles) {
                            user.attachedFiles = []
                        } else {
                            if (res.attachedFileType === 'CERTIFICATE_OF_INCORPORATION_BUSINESS_REGISTRATION') {
                                user.ceftificateOfIncorporation = res;
                            }

                        }
                    }
                    this.setState({corporateAccountUsers})
                })
                .catch(displayGenericError);
        }
    };
    handleRemoveFile = ({id, type, index, itemId}) => {
        deleteFile(id)
            .then((res) => {
                if (!(typeof index === "number")) {
                    let corporateAccountUsers = this.state.corporateAccountUsers;
                    let user = this.state.corporateAccountUsers.filter(s => s.id === itemId)[0];
                    if (user.crpAccType === 'INDIVIDUAL') {
                        if (type === 'IDENTITY_CARD_FRONT') {
                            user.identityCardFront = null;
                        } else if (type === 'IDENTITY_CARD_BACK') {
                            user.identityCardBack = null;
                        } else if (type === 'PASSPORT') {
                            user.passport = null;
                        } else if (type === 'PROOF_OF_ADDRESS') {
                            user.proofOfAddress = null;
                        }
                    } else {
                        if (type === 'CERTIFICATE_OF_INCORPORATION_BUSINESS_REGISTRATION') {
                            user.ceftificateOfIncorporation = null;
                        }
                    }
                    this.setState({corporateAccountUsers})
                    // this.getCorporateAccountDetails();
                }
            })
            .catch(displayGenericError);
    };
    getCorporateAccountDetails = () => {
        getCorporateAccountDetails()
            .then(corporateAccount => {
                if (corporateAccount.id) {
                    getCorporateAccountUserDetails(corporateAccount.id)
                        .then(corporateAccountUsers => {
                                if (corporateAccountUsers.length > 0) {
                                    corporateAccountUsers.map((user, idx) => {
                                        this.bindingCorpUserData(user)
                                    });

                                    this.setState({corporateAccountUsers})
                                }
                            }
                        )
                        .catch(displayGenericError);
                }
            });

    }
    bindingCorpUserData = (user) => {
        user.documentType = 'identityCard';
        if (user.ubo) {
            user.crpUserType = 'UBO';
        } else if (user.shareholder) {
            user.crpUserType = 'Shareholder';
        } else if (user.director) {
            user.crpUserType = 'Director';
        } else if (user.authorizedPerson) {
            user.crpUserType = 'Authorized_User';
        }
        if (user.crpAccType === 'INDIVIDUAL') {
            if (!user.attachedFiles) {
                user.attachedFiles = []
            } else {
                let identityCardFront = user.attachedFiles.filter(file => file.attachedFileType === 'IDENTITY_CARD_FRONT');
                let identityCardBack = user.attachedFiles.filter(file => file.attachedFileType === 'IDENTITY_CARD_BACK');
                let passport = user.attachedFiles.filter(file => file.attachedFileType === 'PASSPORT');
                let proofOfAddress = user.attachedFiles.filter(file => file.attachedFileType === 'PROOF_OF_ADDRESS');
                let nationalities = this.state.nationalities.filter(s => s.nationalityCode === user.nationality);
                if (nationalities) {
                    user.nationality = nationalities[0].nationality;
                }

                let countries = this.state.countries.filter(s => s.countryCode === user.countryOfResidence);
                if (countries) {
                    user.countryOfResidence = countries[0].country;
                }
                let idTypes = this.state.idTypes.filter(s => s.code === user.idType);
                if (idTypes) {
                    user.idType = idTypes[0].value;
                }
                user.identityCardFront = identityCardFront[0];
                user.identityCardBack = identityCardBack[0];
                user.passport = passport[0];
                user.proofOfAddress = proofOfAddress[0];

                if (user.passport || user.proofOfAddress) {
                    user.documentType = 'passport'
                }
            }
        } else {
            if (!user.attachedFiles) {
                user.attachedFiles = []
            } else {
                let ceftificateOfIncorporation = user.attachedFiles.filter(file => file.attachedFileType === 'CERTIFICATE_OF_INCORPORATION_BUSINESS_REGISTRATION');
                user.ceftificateOfIncorporation = ceftificateOfIncorporation[0];

                let countries = this.state.countries.filter(s => s.countryCode === user.corpCountry);
                if (countries) {
                    user.corpCountry = countries[0].country;
                }
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        this.getCorporateAccountDetails();
    }

    componentDidMount() {
        getNationalityList()
            .then(response => {
                this.setState({
                    nationalities: response
                }, () => {
                    getCountryList()
                        .then(response => {
                            getIdType().then(idTypes => {
                                this.setState({
                                    idTypes: idTypes,
                                    countries: response
                                },()=>{
                                    this.getCorporateAccountDetails();
                                });

                            }).catch(error => {
                                displayGenericError(error);
                            });
                        })
                        .catch(error => {
                            displayGenericError(error);
                        });

                });
            })
            .catch(error => {
                displayGenericError(error);
            });

    }

    onFieldChanged = (idx, field, val) => {
        let temp = this.state.corporateAccountUsers;
        let user = temp[idx];
        user[field] = val;

        this.setState({
            corporateAccountUsers: temp
        });
    }

    isSubmitButtonDisabled = () => {
        let disabled = false;
        this.state.corporateAccountUsers.map((user, idx) => {
            if (user.crpAccType === 'INDIVIDUAL') {
                if (!(user.identityCardFront && user.identityCardBack) && !(user.passport && user.proofOfAddress)) {
                    disabled = true;
                }


            } else {
                if (!user.ceftificateOfIncorporation) {
                    disabled = true;
                }
            }
        })
        return disabled;
    }
    handleSubmit = () => {
        this.props.handleSubmit();

    }

    render() {
        return (
            <div className="general-info-tab">
                <div className="left-pane" style={{paddingTop: '0px'}}>

                    {this.state.corporateAccountUsers.map((user, idx) => {
                        return (
                            <div>

                                {user.crpAccType === "INDIVIDUAL" && (
                                    <div>
                                        {/*<Form.Item*/}
                                        {/*    label="Document Type">*/}
                                        {/*    <Radio.Group name="documentType" value={user.documentType}*/}
                                        {/*                 onChange={e => this.onFieldChanged(idx, 'documentType', e.target.value)}>*/}
                                        {/*        <Radio.Button value="identityCard">Identity Card</Radio.Button>*/}
                                        {/*        <Radio.Button value="passport">Passport</Radio.Button>*/}
                                        {/*    </Radio.Group>*/}
                                        {/*</Form.Item>*/}
                                        {user.documentType === 'identityCard' && (
                                            <Row gutter={16}>

                                                <Col className="gutter-row" span={12}>
                                                    <UploadWrapper
                                                        upload={this.handleUpload}
                                                        file={
                                                            user.identityCardFront
                                                        }
                                                        title="Identity Card (Front)"
                                                        type="IDENTITY_CARD_FRONT"
                                                        itemId={user.id}
                                                        handleRemoveFile={this.handleRemoveFile}
                                                        disabled={true}
                                                    />
                                                </Col>

                                                <Col className="gutter-row" span={12}>
                                                    <UploadWrapper
                                                        upload={this.handleUpload}
                                                        file={
                                                            user.identityCardBack
                                                        }
                                                        title="Identity Card (Back)"
                                                        type="IDENTITY_CARD_BACK"
                                                        itemId={user.id}
                                                        handleRemoveFile={this.handleRemoveFile}
                                                        disabled={true}
                                                    />
                                                </Col></Row>)}

                                        {user.documentType === 'passport' && (
                                            <Row gutter={16}>

                                                <Col className="gutter-row" span={12}>
                                                    <UploadWrapper
                                                        upload={this.handleUpload}
                                                        file={
                                                            user.passport
                                                        }
                                                        title="Passport"
                                                        type="PASSPORT"
                                                        handleRemoveFile={this.handleRemoveFile}

                                                        itemId={user.id}
                                                        disabled={true}
                                                    />
                                                </Col>

                                                <Col className="gutter-row" span={12}>
                                                    <UploadWrapper
                                                        upload={this.handleUpload}
                                                        file={
                                                            user.proofOfAddress
                                                        }
                                                        title="Proof of Residential Address"
                                                        type="PROOF_OF_ADDRESS"
                                                        handleRemoveFile={this.handleRemoveFile}
                                                        itemId={user.id}
                                                        disabled={true}
                                                    />
                                                </Col></Row>)}
                                    </div>

                                )}
                                {user.crpAccType === "CORPORATE" && (
                                    <Row gutter={16}>

                                        <Col className="gutter-row" span={12}>

                                            <UploadWrapper
                                                upload={this.handleUpload}
                                                file={
                                                    user.ceftificateOfIncorporation
                                                }
                                                title="Certificate of Incorporation / Business Registration"
                                                type="CERTIFICATE_OF_INCORPORATION_BUSINESS_REGISTRATION"
                                                handleRemoveFile={this.handleRemoveFile}
                                                itemId={user.id}
                                                disabled={true}

                                            />
                                        </Col>
                                    </Row>)}
                                <Row gutter={16}>
                                    <Col className="gutter-row" span={12}>
                                        <Form.Item label="User Type" required="true">

                                            <label>{user.crpUserType ? user.crpUserType : "UBO"}</label>
                                        </Form.Item>
                                    </Col>

                                    <Col className="gutter-row" span={12}>
                                        <Form.Item label="Account Type" required="true">


                                            <label>{user.crpAccType ? user.crpAccType : "INDIVIDUAL"}</label>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                {user.crpAccType === "INDIVIDUAL" && (
                                    <div>

                                        <Row gutter={16}>
                                            <Col className="gutter-row" span={12}>
                                                <Form.Item label="First Name" required="true">

                                                    <label>{user.firstName}</label>
                                                </Form.Item>
                                            </Col>
                                            <Col className="gutter-row" span={12}>
                                                <Form.Item label="Last Name" required="true">

                                                    <label>{user.lastName}</label>
                                                </Form.Item>
                                            </Col>


                                        </Row>
                                        <Row gutter={16}>
                                            <Col className="gutter-row" span={12}>
                                                <Form.Item label="Nationality" required="true">

                                                    <label>{user.nationality}</label>
                                                </Form.Item>
                                            </Col>
                                            <Col className="gutter-row" span={12}>
                                                <Form.Item label="Country of residency" required="true">

                                                    <label>{user.countryOfResidence}</label>
                                                </Form.Item>
                                            </Col>
                                        </Row>

                                        <Row gutter={16}>
                                            <Col className="gutter-row" span={12}>
                                                <Form.Item label="Id type" required="true">

                                                    <label>{user.idType}</label>
                                                </Form.Item>
                                            </Col>
                                            <Col className="gutter-row" span={12}>
                                                <Form.Item label="Id Number" required="true">

                                                    <label>{user.idNumber}</label>
                                                </Form.Item>
                                            </Col>
                                        </Row>

                                        <Row gutter={16}>
                                            <Col className="gutter-row" span={12}>
                                                <Form.Item label="Date Of Birth" required="true">
                                                    <label>{user.dateOfBirth}</label>
                                                </Form.Item>
                                            </Col>
                                            <Col className="gutter-row" span={12}>
                                                <Form.Item label="Country Of Birth" required="true">

                                                    <label>{user.countryOfBirth}</label>
                                                </Form.Item>
                                            </Col>
                                        </Row>

                                        <Row gutter={16}>

                                            <Col className="gutter-row" span={12}>
                                                <Form.Item label="Email" required="true">

                                                    <label>{user.email}</label>
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </div>
                                )}

                                {user.crpAccType === "CORPORATE" && (
                                    <div>

                                        <Row gutter={16}>
                                            <Col className="gutter-row" span={12}>
                                                <Form.Item label="Name of Business" required="true">

                                                    <label>{user.corpName}</label>
                                                </Form.Item>
                                            </Col>
                                            <Col className="gutter-row" span={12}>
                                                <Form.Item label="Country" required="true">

                                                    <label>{user.corpCountry}</label>
                                                </Form.Item>
                                            </Col>
                                        </Row>


                                        <Row gutter={16}>
                                            <Col className="gutter-row" span={12}>
                                                <Form.Item label="Business No.">

                                                    <label>{user.idNumber}</label>
                                                </Form.Item>
                                            </Col>
                                            <Col className="gutter-row" span={12}>
                                                <Form.Item label="Email" required="true">

                                                    <label>{user.email}</label>
                                                </Form.Item>
                                            </Col>
                                        </Row>

                                    </div>

                                )}
                                <Divider/>

                            </div>


                        )
                    })}


                </div>
            </div>
        )
    }

}